import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ef93dee")

_pushScopeId("data-v-7ef93dee")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = { class: "toc_ui__reminder_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_cnt" }, [
  /*#__PURE__*/_createVNode("span", null, "1.车辆信息仅供参考，实际车型与配置信息请以实车为准，此证书手写无效；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "3.90天回购保障，须具备中国汽研二手车检测保障承诺书，单独出具此检测评估报告不具备法律效力；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "4.中国汽研检测标准符合国家二手车鉴定标准和CADA团体标准，中国汽研对报告起监督职责，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。")
], -1)
const _hoisted_5 = { class: "toc_ui__reminder_body" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_cnt" }, [
  /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写⽆效；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "2.⻋辆基本照⽚仅供参考，实际⻋辆状况以售卖⻋辆为准；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "4.90天回购保障，须具备中国汽研⼆⼿⻋检测保障承诺书，单独出具此检测评估报告不具备法律效⼒；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "5.中国汽研检测标准符合国家⼆⼿⻋鉴定标准和CADA团体标准，中国汽研对报告起监督职责，如对检测标准有异议，或您需要对检测报告进⾏解读，请拨打400-808-3718咨询。"),
  /*#__PURE__*/_createVNode("br")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "toc_ui__anti_body"
}
const _hoisted_9 = { class: "toc_ui__anti_farkurl" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4
    ], 512), [
      [_vShow, _ctx.state.channelType !== 'lingshou' && (!_ctx.state.reportTipVersion || _ctx.state.reportTipVersion < 240326)]
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7
    ], 512), [
      [_vShow, _ctx.state.channelType !== 'lingshou' && _ctx.state.reportTipVersion && _ctx.state.reportTipVersion >= 240326]
    ]),
    (_ctx.state.antiFakeUrl)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("img", {
              src: _ctx.state.antiFakeUrl
            }, null, 8, ["src"])
          ]),
          _hoisted_10
        ]))
      : _createCommentVNode("", true)
  ]))
})